"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useKeyPressOnce = void 0;

var use_update_effect_1 = require("./use-update-effect");

var use_key_press_1 = require("./use-key-press");

function useKeyPressOnce(key, keyup, keydown) {
  var _a = use_key_press_1.useKeyPress(key),
      pressed = _a[0],
      event = _a[1];

  use_update_effect_1.useUpdateEffect(function () {
    if (!pressed && !!keyup) {
      keyup(event);
    } else if (pressed && !!keydown) {
      keydown(event);
    }
  }, [pressed]);
}

exports.useKeyPressOnce = useKeyPressOnce;